/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: garry彭
 * @LastEditTime: 2023-12-17 19:59:56
 */
import React from 'react'

import styles from './index.module.scss'
import { InfoCircleOutlined } from '@ant-design/icons'

export default ({ imgUrl }) => {
  return (
    <>
      <div className={styles.imgWrapper}>
        <img src={imgUrl} className={styles.preview} alt="" />
      </div>
      <div className={styles.tip}>
        <InfoCircleOutlined style={{ fontSize: 12, marginRight: 2 }} />
        当前照片下载后不含“今日水印相机”水印
      </div>
    </>
  )
}
